export enum ServiceAccess {
  AVAILABLE = 'available',
  PENDING = 'pending',
  APPROVED = 'approved'
}

export type ServiceAttributes = {
  name: string;
  description: string;
  imageUrl: string;
  iamGroup: string;
  serviceUrl: string;
  access: ServiceAccess;
};

export type Service = {
  type: string;
  attributes: ServiceAttributes;
};

export type ServiceListResponse = {
  data: Service[];
};

export type ServiceQuery = {
  languageCode?: string;
  countryCode?: string | null;
};

export type ServiceData = {
  iamGroup: string;
};
